import axios from "axios";
import BaseService from "./baseService";
import appState from "../state/AppStateContainer";

export type EmailPreviewType = "bidRequest" | "dateChange" | "erfa" | "contractSignature";

export type EmailPreviewParams = {
  recipientName?: string,
  areaName?: string,
  projectName?: string,
  supplierName?: string,
  title?: string,
  expiryDate?: string,
  // 0-based version index, like the send paths use; null hides the version
  // row (a bulk deadline change spans several versions).
  versionNo?: number | null,
  emailText?: string,
};

class ServiceEmailPreviewController extends BaseService {
  async getPreview(type: EmailPreviewType, params: EmailPreviewParams) {
    const orgSlug = appState.getCurrentOrgSlug();
    const response = await axios.post(`/api/organizations/${orgSlug}/email/preview`, { type, params });
    return response.data as { html: string };
  }
}

export const ServiceEmailPreview = new ServiceEmailPreviewController();
